import request from '@/utils/request2';
export function getBlackList(data) {
  return request.post('admin/insured-blacklist/list', data);
}
export function addBlackList(data) {
  return request.post('admin/insured-blacklist/add', data);
}
export function deleteBlackList(data) {
  return request.post('admin/insured-blacklist/delete', data);
}
export function blacklistVerifyData(data) {
  return request.post('admin/insured-blacklist/import-verify', data);
}
export function blacklistImportData(data) {
  return request.post('admin/insured-blacklist/import', data);
}
export function blacklistExport(data) {
  return request.post('admin/insured-blacklist/export', data);
}